import { create } from "zustand";
import { ExcelStoreProps } from "./interface/excel-store.interface";

const currentYear = new Date().getFullYear();

export const excelStore = create<ExcelStoreProps>((set) => ({
  selectedYear: currentYear,
  queryStr: "",
  additional: 30000,
  setSelectedYear: async (value: number | string) => {
    set(() => ({
      selectedYear: value,
    }));
  },
  setQueryStr: async (value: string) => {
    set(() => ({
      queryStr: value,
    }));
  },

  setAdditional: async (value: number) => {
    set(() => ({
      additional: value,
    }));
  },
}));
